import { FontCategory } from '@quicktools/shared-components/data/fonts';

const props = {
  canonicalPath: 'text/font-generator/fancy/',
  headTitle: 'Free Fancy Text Fonts',
  headDescription:
    'Picsart offers a simple and completely free fancy text generator to transform your text for graphic design, social media, business purposes, and more.',
  heading: 'Fancy Text Generator for Elegant and Formal Fonts',
  description: 'An assortment of fancy text fonts to class up your content for any audience.',
  selectedCategory: FontCategory.Fancy,
  inputPlaceholder: 'Write to unlock fancy fonts…',
  landingText: {
    imageSection: [
      {
        imgSrc: 'https://cdn140.picsart.com/22876886335104388500.webp',
        imgAlt: 'fancy text generator',
        imageWidth: 355,
        imageRight: false,
        title: 'Easy-to-use fancy text generator for social media and more',
        children: {
          paragraph: `Fancy text and <a className='link--underline' href='https://picsart.com/fonts/?style=Fancy/' target='_blank'>fancy font styles</a> are popular in graphic design, social media, content creation, and more as an easy method for grabbing a viewer’s attention and helping to stand out from the digital crowd. By converting your text into free fancy fonts, you can take ordinary or normal content and add a unique flourish that can showcase your personal style or aesthetic, whether for personal or professional reasons. The Picsart fancy font generator makes fancifying your text easier than ever before. All you need is the text you want to convert and a few seconds, and you can create fancy text for any occasion.`,
        },
      },
      {
        imgSrc: 'https://cdn140.picsart.com/06350059335479530960.webp',
        imgAlt: 'fancy text',
        imageWidth: 253,
        imageRight: true,
        title: 'Why use the Picsart fancy font generator?',
        children: {
          paragraph:
            'Not sure why you might need free fancy fonts or a fancy text generator? Here are just some the ways fancy fonts can be a great idea for you:',
          list: [
            'For helping a professional or brand website or social media page jump off a viewer’s feed as they scroll through.',
            'To communicate a personal style or aesthetic that fits with the design of your page or your brand kit.',
            'To create eye-catching infographics and visuals that can liven up a presentation or document.',
            'To add an artistic or creative flourish to text in any setting.',
          ],
          additionalText:
            'The Picsart fancy text generator is completely free, requires no registration, and won’t bother you with pesky adds. All you need to do is copy and paste your text, choose the free fancy fonts you like best, and then copy your converted text into your desired app, web page, or document. No experience necessary!',
        },
      },
    ],
    howToSection: {
      title: 'How to use the fancy text generator',
      steps: [
        {
          title: 'Copy & paste your text',
          description:
            'Choose the text you want to transform into a fancy font, and then copy and paste it into the fancy text generator to begin.',
        },
        {
          title: 'Pick your favorite fancy font',
          description:
            'Browse a variety of free fancy fonts to find the style that you like the best, or that you think will work best for your needs.',
        },
        {
          title: 'Copy your transformed text',
          description:
            'Once you are finished using the fancy font generator, simply copy your converted text back into your app, web page, or document and you’re done!',
        },
      ],
      cta: 'Get Started!',
    },
    similarTools: {
      paragraph:
        'Looking for more than just a fancy text generator? Check out the Picsart suite of text editing and graphics tools to find whatever you need.',
    },
    moreInfo: {
      title: 'Need some more info?',
      description: 'Picsarts friendly support team will be happy to help.',
      btn: 'Get in touch',
    },
  },
};

export default props;
